<template lang="html">
    <section class="card" :class="{flip : !list.href}">
        <div class="card-front">
            <img :src="list.src" alt="">
            <div class="text">
                {{list.showName}}
            </div>

            <div class="badge" v-if="list.benefitType === '2' && list.surplusAmount>0 && list.categoryId !== 15">
                {{list.surplusAmount | formatAmount(list)}}{{list.benefitSpec | formatUnit}}
            </div>

            <div class="card-btn" @click="upgrade(list)" v-if="list.href">
                升级
            </div>
        </div>
        <div class="card-back">
            <span>{{list.introduce}}</span>
        </div>
    </section>
</template>

<script>
import {
    getMemberExperience
} from 'api/account'

export default {
    data () {
        return {
            loading: false
        }
    },
    props: ['list'],
    filters: {
        formatUnit (val) {
            let opt = {
                1: '有',
                2: '天',
                3: '折',
                4: '次',
                5: '个',
                6: '不限',
                7: '无',
                8: '倍',
                9: '秒',
                10: '兆',
                11: '人',
                12: '条',
                13: '行'
            }
            return opt[val]
        },
        formatAmount (val, item) {
            if (item.benefitSpec === '3') {
                return val === 1 ? 0 : val / 100
            } else if (item.benefitSpec === '8') {
                return val / 100
            } else {
                return val
            }
        }
    },
    methods: {
        upgrade (item) {
            if (this.loading) {
                return
            }
            this.loading = true

            let params = {
                categoryId: item.categoryId,
                relId: item.relId
            }
            getMemberExperience(params).then(res => {
                if (res.data.success) {
                    this.$toast({
                        message: '恭喜您，成功升级为会员'
                    })
                    window.location.reload()
                }
            })
                .catch(err => {
                    console.log(err, 'err')
                })
                .finally(() => {
                    // 免费领取创意云只能点一次
                    if (item.categoryId !== 15) {
                        this.loading = false
                    }
                })
        }
    }
}
</script>

<style lang="scss" scoped="true">
@import 'styles/mixin.scss';
@mixin base{
    height: 100%;
    width: 100%;
     position: absolute;
     -webkit-backface-visibility: hidden;
     backface-visibility: hidden;
     transform-style: preserve-3d;
     transition: ease-in-out 600ms;
}
.card-front{
    @include base;
    color: #333333;
    font-size: 14px;
    background-color: #EEF2F8;
    padding-top: 30px;
    text-align: center;
    img{
        width: 36px;
    }
    .text{
        width: 147px;
        margin: 0 auto;
        margin-top: 24px;
    }
    .card-btn{
        @include button-yellow;
        margin: 0 auto;
        margin-top: 12px;
    }
}
.card-back{
    @include base;
    display: none;
    justify-content: center;
    align-items: center;
    padding: 0 24px;
    text-align: center;
    color: #FFFFFF;
    font-size: 13px;
    background:rgba(0,0,0,0.9);
    box-shadow:0px 4px 20px 0px rgba(0,0,0,0.08);
    border-radius:3px;
}
.card{
    position: relative;
    width: 230px;
    height: 160px;
    .badge{
        position: absolute;
        line-height: 18px;
        min-width: 32px;
        font-size: 12px;
        text-align: center;
        right: 0;
        top: -8px;
        z-index: 3;
        color: #673416;
        background: #FCDEB1;
        border-radius:8px 0px 8px 0px;
        padding: 0px 8px;
        height: 18px;
    }
}
.flip:hover{
    .card-back{
        display: flex;
    }
}
</style>
